// HERO
// ===================================================

var hero = {

    settings: {
        hero_info_boxes: $('.block-hero-additional-info-boxes'),
        video_controls: $('.video-controls'),
    },

    init: function() {
        // Hero Info Boxes
        if (this.settings.hero_info_boxes.length) {
            this.heroInfoBoxSlider();
        }
        // Video Controls
        if (this.settings.video_controls.length) {
            this.videoControls();
        }
    },

    // Hero Info Box Slider
    heroInfoBoxSlider: function() {

        var swiper = new Swiper(hero.settings.hero_info_boxes.find('.swiper')[0], {
            enabled: true,
            loop: false,
            navigation: {
                nextEl: '.swiper-arrow.next',
                prevEl: '.swiper-arrow.prev',
            },
            observeParents: true,
            pagination: {
                clickable: false,
                el: '.swiper-dots',
            },
            slidesPerView: 'auto',
            breakpoints: {
                960: {
                    enabled: false,
                    slidesPerView: $(this).data('slide-count'),
                },
            },
        });

    },

    // Video Controls
    videoControls: function() {

        hero.settings.video_controls.each(function() {

            // Vimeo
            if ($(this).data('vimeo-video-id')) {
                
                var iframe = $(this).closest('section').find('iframe');
                var player = new Vimeo.Player(iframe);
                var controls = $(this);

                controls.on('click keydown', function(e) {
                    if (global_helpers.accessibilityButtons(e)) {
                        if (controls.hasClass('playing')) {
                            // Pause Video
                            controls.removeClass('playing');
                            controls.addClass('paused');
                            player.pause();
                        } else {
                            // Play Video
                            controls.removeClass('paused');
                            controls.addClass('playing');
                            player.play();
                        }
                    }
                });

            }

            // Wistia
            if ($(this).data('wistia-video-id')) {
                
                var video_id = $(this).data('wistia-video-id');
                var controls = $(this);
    
                _wq.push({ id: video_id, onReady: function(video) {
                    
                    controls.on('click keydown', function(e) {
                        if (global_helpers.accessibilityButtons(e)) {
                            if (controls.hasClass('playing')) {
                                // Pause Video
                                controls.removeClass('playing');
                                controls.addClass('paused');
                                video.pause();
                            } else {
                                // Play Video
                                controls.removeClass('paused');
                                controls.addClass('playing');
                                video.play();
                            }
                        }
                    });
    
                }});

            }

        });

    },

};
hero.init();